<template>
  <div class="map_wrapper">
    <GmapMap
      :center="{ lat: parseFloat(lat), lng: parseFloat(lng) }"
      :zoom="12"
      map-type-id="terrain"
      style="width: 100%; height: 400px"
      @click="onMapClick"
    >
      <GmapMarker
        :position="{ lat: parseFloat(lat), lng: parseFloat(lng) }"
        :clickable="true"
        :draggable="true"
        @dragend="onMarkerDragEnd"
      />
    </GmapMap>
  </div>
</template>


<script>
export default {
  name: "MapComponent",
  props: {
    lat: {
      type: Number,
      required: true,
    },
    lng: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      placeName: "",
    };
  },

  mounted() {
    if (window.google) {
      const input = this.$refs.searchInput;
      const autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
          const newLat = place.geometry.location.lat();
          const newLng = place.geometry.location.lng();

          this.$emit("update:lat", newLat);
          this.$emit("update:lng", newLng);
          this.placeName = place.formatted_address || place.name;
          this.$emit("update:placeName", this.placeName);
        }
      });
    }
  },

  methods: {
    onMarkerDragEnd(event) {
      const newLat = event.latLng.lat();
      const newLng = event.latLng.lng();

      this.$emit("update:lat", newLat);
      this.$emit("update:lng", newLng);
      this.getPlaceName(newLat, newLng);
    },

    onMapClick(event) {
      const clickedLat = event.latLng.lat();
      const clickedLng = event.latLng.lng();

      this.$emit("update:lat", clickedLat);
      this.$emit("update:lng", clickedLng);
      this.getPlaceName(clickedLat, clickedLng);
    },

    getPlaceName(lat, lng) {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat, lng };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.placeName = results[0].formatted_address;
        } else {
          this.placeName = "Unknown Location";
        }
        this.$emit("update:placeName", this.placeName);
      });
    },
  },
};

</script>

<style scoped>
.map_wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-search-input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.place-label {
  display: block;
  margin: 10px 0;
  font-size: 16px;
  font-weight: bold;
}
</style>